import React, { useState } from "react";
import { Modal, Button, Input, message } from "antd";
import { Row, Col } from "reactstrap";
import { CustomLabel, ErrorMessage } from "../../../utilities/utll";
import { apiRequest } from "../../../utilities/apiMethod";

export const ChangePasswordModal = ({ open, onCancel }) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [formDetails, setFormDetails] = useState({
    userName: "",
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setFormDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error for this field when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formDetails.userName || formDetails.userName.trim() === "") {
      newErrors.userName = "Username is required";
    }

    if (!formDetails.oldPassword || formDetails.oldPassword.trim() === "") {
      newErrors.oldPassword = "Old password is required";
    }

    if (!formDetails.newPassword || formDetails.newPassword.trim() === "") {
      newErrors.newPassword = "New password is required";
    } else if (formDetails.newPassword.length < 6) {
      newErrors.newPassword = "New password must be at least 6 characters";
    }

    if (
      !formDetails.confirmPassword ||
      formDetails.confirmPassword.trim() === ""
    ) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (formDetails.newPassword !== formDetails.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const payload = {
        userName: formDetails.userName,
        oldPassword: formDetails.oldPassword,
        newPassword: formDetails.newPassword,
        confirmPassword: formDetails.confirmPassword,
      };

      const response = await apiRequest(
        "POST",
        "Users/changepassword",
        payload
      );

      if (response.IsSuccess) {
        messageApi.success(
          response.displayMessage || "Password changed successfully!"
        );
        // Reset form
        setFormDetails({
          userName: "",
          oldPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
        setErrors({});
        setTimeout(() => {
          onCancel();
        }, 1000);
      } else {
        if (response.errorMessage && response.errorMessage.length > 0) {
          response.errorMessage.forEach((err) => {
            messageApi.error(err);
          });
        } else {
          messageApi.error(
            response.displayMessage || "Failed to change password"
          );
        }
      }
    } catch (error) {
      console.error("Error changing password:", error);
      messageApi.error(
        "An error occurred while changing password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    // Reset form and errors
    setFormDetails({
      userName: "",
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setErrors({});
    onCancel();
  };

  return (
    <>
      {contextHolder}
      <Modal
        key="changePasswordForm"
        open={open}
        title="Change Password"
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel} disabled={loading}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={handleSubmit}
            loading={loading}
          >
            Change Password
          </Button>,
        ]}
        width={600}
      >
        <Row style={{ marginTop: "20px" }}>
          <Col xl={12} md={12} sm={12}>
            <CustomLabel children={"Username"} isImportnt={true} />
            <Input
              name="userName"
              id="userName"
              type="text"
              placeholder="Enter Username"
              size="large"
              value={formDetails?.userName ?? ""}
              onChange={(e) => handleChange("userName", e.target.value)}
              status={errors.userName ? "error" : ""}
            />
            <ErrorMessage error={errors.userName} />
          </Col>
        </Row>

        <Row style={{ marginTop: "15px" }}>
          <Col xl={12} md={12} sm={12}>
            <CustomLabel children={"Old Password"} isImportnt={true} />
            <Input.Password
              name="oldPassword"
              id="oldPassword"
              placeholder="Enter Old Password"
              size="large"
              value={formDetails?.oldPassword ?? ""}
              onChange={(e) => handleChange("oldPassword", e.target.value)}
              status={errors.oldPassword ? "error" : ""}
            />
            <ErrorMessage error={errors.oldPassword} />
          </Col>
        </Row>

        <Row style={{ marginTop: "15px" }}>
          <Col xl={12} md={12} sm={12}>
            <CustomLabel children={"New Password"} isImportnt={true} />
            <Input.Password
              name="newPassword"
              id="newPassword"
              placeholder="Enter New Password"
              size="large"
              value={formDetails?.newPassword ?? ""}
              onChange={(e) => handleChange("newPassword", e.target.value)}
              status={errors.newPassword ? "error" : ""}
            />
            <ErrorMessage error={errors.newPassword} />
          </Col>
        </Row>

        <Row style={{ marginTop: "15px" }}>
          <Col xl={12} md={12} sm={12}>
            <CustomLabel children={"Confirm Password"} isImportnt={true} />
            <Input.Password
              name="confirmPassword"
              id="confirmPassword"
              placeholder="Confirm New Password"
              size="large"
              value={formDetails?.confirmPassword ?? ""}
              onChange={(e) => handleChange("confirmPassword", e.target.value)}
              status={errors.confirmPassword ? "error" : ""}
            />
            <ErrorMessage error={errors.confirmPassword} />
          </Col>
        </Row>
      </Modal>
    </>
  );
};
